import React from 'react';
import { isProduction } from 'js/sign-components/common/ts-utils';
import HSIntlProvider from 'hellospa/common/hs-intl-provider';

const PAPEventDebugPanel = React.lazy(async () => {
  const { PAPEventDebugPanelContainer } = await import(
    './pap-event-debug-panel'
  );
  return { default: PAPEventDebugPanelContainer };
});

function LazyPAPEventDebugPanel() {
  const isProd = isProduction();
  const [isToolbarPresent, setIsToolbarPresent] = React.useState(
    () => !isProd && document.readyState !== 'loading' && hasDebugToolbar(),
  );

  React.useEffect(() => {
    if (isProd) {
      return undefined;
    }

    if (document.readyState !== 'loading') {
      setIsToolbarPresent(hasDebugToolbar());
      return undefined;
    }

    const onLoaded = () => setIsToolbarPresent(hasDebugToolbar());
    document.addEventListener('DOMContentLoaded', onLoaded);
    return () => document.removeEventListener('DOMContentLoaded', onLoaded);
  }, [isProd]);

  if (isProd || !isToolbarPresent) {
    return null;
  }

  return (
    <React.Suspense fallback={null}>
      <HSIntlProvider>
        <PAPEventDebugPanel />
      </HSIntlProvider>
    </React.Suspense>
  );
}

function hasDebugToolbar() {
  return document.getElementById('hs-debug-tools') !== null;
}

export const lazyPAPEventDebugPanel = <LazyPAPEventDebugPanel />;
